import { render, staticRenderFns } from "./panamera.vue?vue&type=template&id=51609142&"
import script from "./panamera.vue?vue&type=script&lang=js&"
export * from "./panamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports